var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"55\" alt=\"\"><br><br><div style=\"width: 240px;\"><h3>If you need help with anything, you can reach out to us by clicking here.</h3></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/tour/intro/step5.jade
// module id = 820
// module chunks = 0